import { Component } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';

@Component({
  selector: 'libero-consult-footer',
  templateUrl: './footer-consult.component.html',
  styleUrl: './footer-consult.component.scss',
  standalone: false
})
export class FooterConsultComponent {
  public currentYear = new Date().getFullYear();

  public reopenCookieModal(): void {
    CookieConsent.show(true);
  }
}
